import * as React from "react";

import TrieveLogo from "../images/trieve_logo.png";
import AdobeLogo from "../images/adobe_logo.svg";
import HingeHealthLogo from "../images/hinge_health_logo.svg";
import CreaLogo from "../images/crea_logo.svg";
import AetnaLogo from "../images/aetna_logo.svg";
import MethodLogo from "../images/method_logo.svg";
import DatchLogo from "../images/datch_logo.svg";
import SpectrocloudLogo from "../images/spectrocloud_logo.svg";
import PointerLogo from "../images/pointer_logo.png";

function Marquee(props: { dir: "ltr" | "rtl"; logos: React.ReactElement[] }) {
  const elements: React.ReactElement[] = [];
  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < props.logos.length; j++) {
      elements.push(
        <div key={`${i}:${j}`} style={{ filter: "grayscale(1) brightness(33%)" }} className="flex justify-center items-center min-w-[105px] scale-[0.85]">
          {props.logos[j]}
        </div>,
      );
    }
  }

  const duration = 240 / props.logos.length;

  return (
    <div className="select-none pointer-events-none w-full flex flex-col">
      <div className="w-full flex justify-center">
        <div className="w-full overflow-hidden relative flex items-center group/marquee">
          <div className="flex items-center">
            <div
              className="h-[40px] w-max min-w-fit flex items-center -group-hover/marquee:animate-paused"
              style={{ animation: `${duration}s linear 0s infinite normal both running ${props.dir === "rtl" ? "marqueeRTL" : "marqueeLTR"}` }}
            >
              {elements.slice(0 * props.logos.length, 1 * props.logos.length)}
            </div>
            <div
              className="h-[40px] w-max min-w-fit flex items-center -group-hover/marquee:animate-paused"
              style={{ animation: `${duration}s linear 0s infinite normal both running ${props.dir === "rtl" ? "marqueeRTL" : "marqueeLTR"}` }}
            >
              {elements.slice(1 * props.logos.length, 2 * props.logos.length)}
            </div>
            <div
              className="h-[40px] w-max min-w-fit flex items-center -group-hover/marquee:animate-paused"
              style={{ animation: `${duration}s linear 0s infinite normal both running ${props.dir === "rtl" ? "marqueeRTL" : "marqueeLTR"}` }}
            >
              {elements.slice(2 * props.logos.length, 3 * props.logos.length)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SocialProof() {
  return (
    <div className="w-full relative flex flex-col items-center space-y-4">
      <div className="pointer-events-none select-none text-center text-zinc-700/90 text-[12px] font-medium">
        With developer signups from
        <br />
        high performance teams worldwide
      </div>
      <div className="z-[0] w-full max-w-[18rem] flex flex-col items-center relative group/logos">
        <Marquee
          dir="ltr"
          logos={[
            <img key="hinge" src={HingeHealthLogo} className="h-[21px]" />,
            <img key="adobe" src={AdobeLogo} className="grayscale h-[18px]" />,
            <img key="crea" src={CreaLogo} className="h-[24px]" />,
          ]}
        />
        <Marquee
          dir="rtl"
          logos={[
            <img key="trieve" src={TrieveLogo} className="h-[40px]" />,
            <img key="datch" src={DatchLogo} className="h-[16px]" />,
            <img key="spectrocloud" src={SpectrocloudLogo} className="h-[36px] invert" />,
          ]}
        />
        <Marquee
          dir="ltr"
          logos={[
            <img key="aetna" src={AetnaLogo} className="h-[14px]" />,
            <img key="method" src={MethodLogo} className="h-[21px]" />,
            <img key="pointer" src={PointerLogo} className="h-[15px] invert" />,
          ]}
        />
        <div style={{ background: "radial-gradient(circle, transparent, transparent 66%, #000000 99%)" }} className="absolute top-0 left-0 w-full h-full" />

        <div className="hidden z-[2] w-full transition-all delay-[200ms] duration-[1000ms] ease-in-out blur-[8px] group-hover/logos:blur-[0px] scale-[1.5] group-hover/logos:scale-[1] flex opacity-[0] group-hover/logos:opacity-[1] pointer-events-none absolute top-0 left-0 w-full h-full justify-center items-center">
          <div className="flex justify-center items-center w-fit relative">
            <div className="z-[2] absolute top-0 left-[-16px] w-[calc(16px+16px)] h-full bg-gradient-to-r from-transparent to-black" />
            <div className="z-[2] absolute top-0 left-[16px] w-[calc(100%-16px-16px)] h-full bg-black" />
            <div className="z-[2] absolute top-0 left-[calc(100%-16px)] w-[calc(16px+16px)] h-full bg-gradient-to-l from-transparent to-black" />
            <div className="z-[3] flex justify-center space-x-3 items-center px-4">
              <span className="text-[10px] text-zinc-300 font-medium text-center">
                Backed by
                <br />Y Combinator
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
